var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "label",
    {
      class: {
        "d-block": true,
        "pb-1": true,
        "red--text text--darken-1": _vm.error
      },
      attrs: {
        "aria-hidden": _vm.ggFor ? "true" : "false",
        for: _vm.ggFor
      }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }